import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../actions/auth-actions';
import { APP_API_URL, APP_NAME } from '../utils';
import axios from 'axios';
import Swal from 'sweetalert2';

const MagasinierHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [pendingCount, setPendingCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleLogout = () => {
    Swal.fire({
      title: 'Êtes-vous sûr de vouloir vous déconnecter ?',
      text: 'Cette action vous déconnectera de votre compte.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#58cc02',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, déconnectez-moi',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        setMenuOpen(false);
        dispatch(logout());
        navigate('/auth/login');
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${APP_API_URL}/completed/commandes`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPendingCount(response.data.commandes?.length ?? 0);
      } catch (error) {
        console.error('Erreur lors de la récupération des commandes :', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const initial = (user?.name?.split(' ')[0] ?? 'U').charAt(0).toUpperCase();

  return (
    <header id="header" className="header duo-header duo-header--caisse fixed-top">
      <div className="duo-header__inner">
        <div className="duo-header__left">
          <Link to="/livraisons" className="duo-header__brand">
            <img src="/assets/img/logo.png" alt={APP_NAME} className="duo-header__logo" />
          </Link>
        </div>

        <div className="duo-header__right" ref={menuRef}>
          <Link to="/livraisons" className="duo-header__validation d-none d-md-flex" title="Livraisons en attente">
            <i className="bi bi-box-seam-fill" aria-hidden />
            {pendingCount > 0 && (
              <span className="duo-header__validation-badge">
                {pendingCount > 9 ? '9+' : pendingCount}
              </span>
            )}
          </Link>

          <button
            type="button"
            className="duo-header__profile-btn"
            onClick={() => setMenuOpen((open) => !open)}
            aria-expanded={menuOpen}
            aria-haspopup="true"
          >
            <span className="duo-header__avatar" aria-hidden>
              {initial}
            </span>
            <span className="duo-header__user-name">{user?.name}</span>
            <i className={`bi bi-chevron-down duo-header__chevron${menuOpen ? ' is-open' : ''}`} aria-hidden />
          </button>

          {menuOpen && (
            <div className="duo-header__dropdown" role="menu">
              <div className="duo-header__dropdown-head">
                <span className="duo-header__dropdown-avatar" aria-hidden>
                  {initial}
                </span>
                <div>
                  <p className="duo-header__dropdown-name">{user?.name}</p>
                  <p className="duo-header__dropdown-email">{user?.email}</p>
                </div>
              </div>
              <ul className="duo-header__dropdown-list">
                <li>
                  <Link to="/edit-profile" className="duo-header__dropdown-item" onClick={() => setMenuOpen(false)}>
                    <i className="bi bi-person" aria-hidden />
                    Mon compte
                  </Link>
                </li>
                <li>
                  <Link to="/livraisons" className="duo-header__dropdown-item" onClick={() => setMenuOpen(false)}>
                    <i className="bi bi-box-seam" aria-hidden />
                    Livraisons
                    {pendingCount > 0 ? ` (${pendingCount})` : ''}
                  </Link>
                </li>
                <li>
                  <Link to="/commandes/history" className="duo-header__dropdown-item" onClick={() => setMenuOpen(false)}>
                    <i className="bi bi-clock-history" aria-hidden />
                    Historique
                  </Link>
                </li>
                <li>
                  <Link to="/rapports" className="duo-header__dropdown-item" onClick={() => setMenuOpen(false)}>
                    <i className="bi bi-journal-text" aria-hidden />
                    Rapports
                  </Link>
                </li>
                <li>
                  <Link to="/summary" className="duo-header__dropdown-item" onClick={() => setMenuOpen(false)}>
                    <i className="bi bi-bar-chart" aria-hidden />
                    Résumé des produits
                  </Link>
                </li>
                <li className="duo-header__dropdown-divider" />
                <li>
                  <button
                    type="button"
                    className="duo-header__dropdown-item duo-header__dropdown-item--danger"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right" aria-hidden />
                    Déconnexion
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default MagasinierHeader;
